import { render, staticRenderFns } from "./AdminChatWidget.vue?vue&type=template&id=3b67d78e&scoped=true"
import script from "./AdminChatWidget.vue?vue&type=script&lang=js"
export * from "./AdminChatWidget.vue?vue&type=script&lang=js"
import style0 from "./AdminChatWidget.vue?vue&type=style&index=0&id=3b67d78e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b67d78e",
  null
  
)

export default component.exports